module.exports = __webpack_public_path__ + "img/sunset-3.b0e3204f.jpeg";